import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const ERROR_MANAGEMENT_ASSIGN_REQUEST = 'ERROR_MANAGEMENT_ASSIGN_REQUEST'
export const ERROR_MANAGEMENT_ASSIGN_SUCCESS = 'ERROR_MANAGEMENT_ASSIGN_SUCCESS'
export const ERROR_MANAGEMENT_ASSIGN_FAILURE = 'ERROR_MANAGEMENT_FAILURE'
export const ERROR_MANAGEMENT_FETCH_REQUEST = 'ERROR_MANAGEMENT_FETCH_REQUEST'
export const ERROR_MANAGEMENT_FETCH_SUCCESS = 'ERROR_MANAGEMENT_FETCH_SUCCESS'
export const ERROR_MANAGEMENT_FETCH_FAILURE = 'ERROR_MANAGEMENT_FETCH_FAILURE'

export function assignError(data) {
  return {
    [CALL_API]: {
      endpoint: '/api/errors/objects/',
      types: [ERROR_MANAGEMENT_ASSIGN_REQUEST, ERROR_MANAGEMENT_ASSIGN_SUCCESS, ERROR_MANAGEMENT_ASSIGN_FAILURE],
      method: 'POST',
      tokenType: API_JWT_TOKEN_NAME,
      body: data,
    },
  }
}

export function fetchErrors() {
  return {
    [CALL_API]: {
      endpoint: '/api/errors/errors/',
      types: [ERROR_MANAGEMENT_FETCH_REQUEST, ERROR_MANAGEMENT_FETCH_SUCCESS, ERROR_MANAGEMENT_FETCH_FAILURE],
      method: 'GET',
      tokenType: API_JWT_TOKEN_NAME,
    },
  }
}
